// 格式化时间戳
export function formatTimestamp(timestamp) {
  const date = new Date(timestamp); // 将时间戳转换为日期对象

  const year = date.getFullYear(); // 获取年份
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 获取月份，并确保两位数
  const day = date.getDate().toString().padStart(2, '0'); // 获取日期，并确保两位数

  return `${year}.${month}.${day}`; // 返回格式化后的日期字符串
}